import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/aio/landingpage-bg1.png'
import _imports_1 from '../../assets/images/aio/landingpage-bg2.png'
import _imports_2 from '../../assets/images/aio/landingpage-bg3.png'
import _imports_3 from '../../assets/images/aio/landingpage-bg4.png'
import _imports_4 from '../../assets/images/aio/landingpage-bg5.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-724a18dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing-container" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img class=\"landing-page-bg\" src=\"" + _imports_0 + "\" data-v-724a18dc><img class=\"landing-page-bg\" src=\"" + _imports_1 + "\" data-v-724a18dc><img class=\"landing-page-bg\" src=\"" + _imports_2 + "\" data-v-724a18dc><img class=\"landing-page-bg\" src=\"" + _imports_3 + "\" data-v-724a18dc><img class=\"landing-page-bg\" src=\"" + _imports_4 + "\" data-v-724a18dc><div class=\"landing-page-bg6\" data-v-724a18dc></div>", 6)
const _hoisted_8 = { class: "landing-btn-zone" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"landing-btn-desc\" data-v-724a18dc><div class=\"landing-logo\" data-v-724a18dc></div><div class=\"landing-btn-title\" data-v-724a18dc><span class=\"landing-btn-info\" data-v-724a18dc>好未来图书APP</span><span class=\"landing-desc\" data-v-724a18dc>点亮你的学习主场</span></div></div>", 1)
const _hoisted_10 = {
  key: 0,
  class: "mask"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wx-tip" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.callApp && $setup.callApp(...args))),
        id: "downloadButton",
        class: "ios-button"
      }, "立即下载")
    ]),
    ($setup.isWxBowser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
      : _createCommentVNode("", true)
  ]))
}